import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, Validators } from '@angular/forms';

@Component({
    selector: 'nx-textfield-input',
    template: `
    <div>
    <label
        *ngIf="showLabel"
        for="textarea">{{label}}<ng-container *ngIf=isRequired()>*</ng-container></label>
        <textarea
            id="textarea"
            [ngModel]="text"
            rows="5" 
            cols="30"
            [placeholder]=placeholder
            (ngModelChange)="onInputChange($event)"
            pInputTextarea 
            [autoResize]="true">
        </textarea>
        <small *ngIf="helpText">{{helpText}}</small>
    </div>
  `,
    styles: [`

  `],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EditTextfieldInputComponent),
            multi: true
        }
    ]
})
export class EditTextfieldInputComponent implements ControlValueAccessor, OnInit {

    ngControl: NgControl;
    isDisabled: boolean;
    @Input() label: string;
    @Input() helpText: string;
    @Input() placeholder: string;
    @Input() rows = 5;
    @Input() cols = 30;
    @Input() showLabel = true;

    text: string;

    private onChange: (value: string) => void;
    private onTouched: () => void;

    constructor(private _injector: Injector) {
    }

    ngOnInit() {
        this.ngControl = this._injector.get(NgControl);
        this.ngControl.valueAccessor = this;
    }

    writeValue(text: string): void {
        this.text = text;
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    onInputChange(event: string): void {
        this.text = event;
        if (this.onChange) {
            this.onChange(this.text);
        }
    }

    onBlur(): void {
        if (this.onTouched) {
            this.onTouched();
        }
    }

    isRequired(): boolean {
        return this.ngControl?.control?.hasValidator(Validators.required);
    }

}